import { render, staticRenderFns } from "./edito-header.vue?vue&type=template&id=f6e5565a"
import script from "./edito-header.vue?vue&type=script&lang=js"
export * from "./edito-header.vue?vue&type=script&lang=js"
import style0 from "./edito-header.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsDoodleText: require('/home/node/app/components/elements/doodle-text/doodle-text.vue').default,ElementsDoodleImage: require('/home/node/app/components/elements/doodle-image/doodle-image.vue').default,ElementsUiWrapper: require('/home/node/app/components/elements/ui-wrapper/ui-wrapper.vue').default,ElementsEditoText: require('/home/node/app/components/elements/edito-text/edito-text.vue').default})
